import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as componentStore from '../../../component-store'

@ngCore.Component({
  imports: [ds.input.text.Component],
  selector: 'atn-segment-dialog-general-tab',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link componentStore.segment.Store} */
  public readonly store = ngCore.inject(componentStore.builder.Store)

  /**
   * Updates {@link componentStore.segment.State.editingSegment} with changed name value
   */
  public nameChangeHandler(name: string | undefined): void {
    this.store.updateEditingSegment({ name })
  }

  /**
   * Updates {@link componentStore.segment.State.editingSegment} with changed alias
   * value
   */
  public aliasChangeHandler(alias: string | undefined): void {
    this.store.updateEditingSegment({ alias })
  }
}
